export const SET_BUSINESS_DATE = 'businessDate/SET_BUSINESS_DATE'
export const ADD_BUSINESS_DATE = 'businessDate/ADD_BUSINESS_DATE'